export default class Carousel {
  init () {
    this.banner();

    const prevArrow = '<a href="" class="c_button c_button_type2 c_button_type2_l c_carousel_prev"></a>';
    const nextArrow = '<a href="" class="c_button c_button_type2 c_button_type2_r c_carousel_next"></a>';

    $('.js_carousel').each(function () {
      const $this = $(this);
      const $next = $this.closest('.c_carousel_inner').next();
      const asNavForSelector = $this.data('as-nav-for-selector');
      $this.slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: $next.find('.js_carousel_arrow_area'),
        dots: true,
        dotsClass: 'c_carousel_thumbnail_list',
        appendDots: $next.find('.js_carousel_thumbnail_area'),
        customPaging: function (slider, i) {
          var thumbSrc = $(slider.$slides[i]).find('img').attr('src');
          return '<img src="' + thumbSrc + '">';
        },
        asNavFor: asNavForSelector
      });
    });

    $('.js_carousel_2').each(function () {
      const $this = $(this);
      const $next = $this.closest('.c_carousel_inner').next();
      const asNavForSelector = $this.data('as-nav-for-selector');
      $this.slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        appendArrows: $next.find('.js_carousel_arrow_area'),
        dots: true,
        dotsClass: 'c_carousel_dot_list',
        appendDots: $next.find('.js_carousel_dot_area'),
        customPaging: function () {
          return '<div class="c_carousel_dot"></div>';
        },
        asNavFor: asNavForSelector
      });
    });

    $('.js_carousel_3').each(function () {
      const $this = $(this);
      const asNavForSelector = $this.data('as-nav-for-selector');
      $this.slick({
        arrows: false,
        dots: false,
        asNavFor: asNavForSelector,
        adaptiveHeight: true
      });
    });

    $('.c_carousel_modal_trigger').on('click', function () {
      const $target = $($(this).attr('href')).children('.js_modal_carousel');
      const index = $(this).prev('.js_carousel, .js_carousel_2').slick('slickCurrentSlide');
      $target.slick('setPosition');
      $target.slick('slickGoTo', index);
    });

    $(window).on('load',function(){
      $('.js_modal_carousel').each(function () {
        const $this = $(this);
        $this.slick({
          prevArrow: prevArrow,
          nextArrow: nextArrow,
          appendArrows: $this.next('.js_modal_carousel_arrow_area'),
          dots: false
        });

        // $this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        //   const originCarouselId = $this.parent().data('origin-carousel');
        //   $(`#${originCarouselId}`).slick('slickGoTo', nextSlide);
        // });
      });
    });

  }

  banner(){
    var mySwiper = new Swiper ('.swiper-container', {
      init: false,
      loop: true,
      spaceBetween: 30,
      slidesPerView: 5,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        reverseDirection: false
      },
      breakpoints: {
        767: {
          slidesPerView: 2,
          centeredSlides : true,
          spaceBetween: 10
        }
      }
    });
    setTimeout(function () {
      mySwiper.init();
      $('.swiper-container').css('opacity', 1);
    }, 0);
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/carousel.js